import React from 'react';
import { WhatsappIcon } from '../Svg';
import './SquareWhatsapp.css'
import { tagOnWhatsappButtonClick } from 'src/Tagging/SalesTagging';

function SquareWhatsapp() {

  const whatsappUs = (e) => {
  
    e.preventDefault();
    tagOnWhatsappButtonClick();
    window.open('https://api.whatsapp.com/send/?phone=27826223509', '_blank');
  };

  return (
    <div className="whatsappbtn-wrapper-button">
      <button className="whatsapp-btn" onClick={whatsappUs}>
        <span className='whatsapp-btn-icon'>
          <WhatsappIcon
            fill= 'black'
            height = '19'
            width = '19' />
        </span>
        WhatsApp us{' '}
      </button>
    </div>
  );
}

export default SquareWhatsapp;
